export function shouldPostIdle({
  status,
  visible,
  lastActivityAt,
  thresholdSeconds,
  now = Date.now(),
}) {
  if (status !== "RUNNING" || !visible) return false;
  const threshold = Number(thresholdSeconds);
  if (!Number.isFinite(threshold) || threshold <= 0 || !lastActivityAt) return false;
  return now - lastActivityAt >= threshold * 1000;
}

export function shouldPostActiveFromActivity({ status, visible, autoResumeEnabled }) {
  if (!visible) return false;
  if (status === "RUNNING") return true;
  if (status === "AUTO_PAUSED" && autoResumeEnabled !== false) return true;
  return false;
}

export function activityMsFromState(data) {
  const parsed = Date.parse(data?.lastActivityTime);
  return Number.isFinite(parsed) ? parsed : Date.now();
}
